interface PriorityIconProps {
  name: string;
  iconUrl?: string | null;
}

const priorityColors: Record<string, string> = {
  Highest: 'text-red-600',
  High: 'text-orange-500',
  Medium: 'text-yellow-500',
  Low: 'text-blue-500',
  Lowest: 'text-gray-400',
};

const priorityArrows: Record<string, string> = {
  Highest: '\u2191\u2191',
  High: '\u2191',
  Medium: '\u2194',
  Low: '\u2193',
  Lowest: '\u2193\u2193',
};

export function PriorityIcon({ name, iconUrl }: PriorityIconProps) {
  if (iconUrl) {
    return <img src={iconUrl} alt={name} className="h-4 w-4" title={name} />;
  }

  const color = priorityColors[name] || 'text-gray-400';
  const arrow = priorityArrows[name] || '-';

  return (
    <span className={`text-xs font-bold ${color}`} title={name}>
      {arrow}
    </span>
  );
}
